import { fromJS } from 'immutable';
import { push } from 'react-router-redux';
import { setMessage } from './systemMessage';
import * as ActionTypes from '../constants/ActionTypes';
import { clearEntity, receiveEntity, receiveEntities } from './entities';
import { replaceBusinessInfo } from './plan';
import { searchMerchantsByInvites, searchActiveMerchants } from './search';
import { toggleAuthenticationModal } from './auth';
import SupplyInvite from '../records/supply-invite';
import SupplyNode from '../records/supply-node';
import Vendor from '../records/vendor';
import { api } from '../store';

import { Events } from 'ui-utilities';

export const hiddenVendors = () => {
  return (dispatch, getState) => {
    return api().get({
      resource: 'vendors?filter[hidden]=true'
    })
    .then(res => dispatch(receiveEntities(res.data)))
  }
}

export const adminVendorSearch = term => {
  return (dispatch, getState) => {
    const vendors = getState().entities.get('vendors');

    return vendors
      .filter(v => v.get('name').toLowerCase().includes(term.toLowerCase()));
  }
}

export const addMerchantsByInvite = invites => {
  return dispatch => {
    invites.map(i => dispatch(receiveEntity({
      contacts: [{
        type: 'email',
        text: i.get('invited_email')
      }],
      id: i.get('id'),
      name: i.get('invited_name'),
      type: 'merchant',
      images: [],
      vendor: {
        description: ''
      }
    })))
  }
}

export const checkInvite = code => {
  return (dispatch, getState) => {
    if (!getState().auth.get('user').get('isLoggedIn')) {
      dispatch({
        type: ActionTypes.SET_INVITE_CODE,
        payload: code
      });
      return dispatch(toggleAuthenticationModal());
    }
  }
}

export const confirmInvite = inviteId => {
  return (dispatch, getState) => {
    const { customer, entities } = getState();

    const vendor = entities
      .get('vendors')
      .get(customer
        .get('account')
        .get('activeVendorId'));

    const invite = entities.get('supplyInvites').get(inviteId).set('accepted', true);

    return invite.$put()
      .then(res => dispatch(searchMerchantsByInvites(vendor.invitesAwaitingApproval())))
      .then(res => new SupplyNode().$get(vendor.id))
      .then(res => Events
        .provide('kissmetrics', true)
        .log(
          'record',
          'Accept Food Source Invitation', {
            vendorId: invite.get('vendor_id'),
            'Merchant Sending': invite.get('vendor_id'),
            'Merchant Accepted': invite.get('invited_name')
          }
        ));
  }
}

export const removeInvite = inviteId => {
  return (dispatch, getState) => {
    let invite = getState().entities.get('supplyInvites').get(inviteId);

    invite.$delete()
      .then(res => {
        invite.get('invited_vendor_id') !== '' && dispatch(clearEntity(getState().entities.get('merchant').find(m => m.vendor_id === invite.get('invited_vendor_id')), 'merchant'));
        dispatch(clearEntity(getState().entities.get('merchant').get(invite.get('id')), 'merchant'));
        dispatch(clearEntity(invite, 'supplyInvites'));
      });
  }
}

export const removePartner = merchant => {
  return (dispatch, getState) => {
    let supplyNode =  getState().entities.get('supplyNodes').find(s => s.get('purchaser_id') === merchant.get('vendor_id') || s.get('supplier_id') === merchant.get('vendor_id'));
    return supplyNode.$delete()
      .then(res => dispatch(clearEntity(merchant, 'merchant')));
  }
}

export const notifyClaim = (email, error) => {
  const resource = 'feature_requests';

  let msg = 'Thanks, your request to be notified has been received.';
  if (error) msg += ' Your claim error report has been sent to our support team as well.';

  return (dispatch, getState) => {
    const merchantId = getState().search.get('selectedMerchantId');

    return api().post({
      resource: resource
    }, api().payload(resource, {
      email_address: email,
      feature: 'multi-claim'
    }))
    .then(res => {
      if (error) {
        return api().post({
          resource: 'support_requests'
        }, api().payload('support_requests', {
          email_address: email,
          topic: 'claim_dispute',
          vendor_id: merchantId
        }));
      }
    })
    .then(res => dispatch(setMessage('success', msg)));
  }
}

export const sendInvitations = invites => {
  return (dispatch, getState) => {
    const { customer, entities } = getState();
    const vendor = entities
      .get('vendors')
      .get(customer
        .get('account')
        .get('activeVendorId'));

    return Promise.all(invites
      .filter(i => i.get('name') !== '')
      .map(i => new SupplyInvite({
        invited_email: i.get('contacts') ? i.contact('email') : i.get('email'),
        invited_name: i.get('name'),
        invited_vendor_id: i.get('vendor_id') || null,
        type: 'supplier',
        vendor_id: customer.get('account').get('activeVendorId')
      }).$create()))
      .then(res => res.forEach(r => Events
        .provide('kissmetrics', true)
        .log(
          'record',
          'Send Food Source Invitation', {
            vendorId: vendor.id,
            'Merchant Sending': vendor.get('name'),
            'Merchant Invited': r.data.attributes.invited_name
          }
        )))
      .then(res => Events
        .provide('kissmetrics', true)
        .log(
          'record',
          'Connected Food Sources', {
            vendorId: vendor.id,
            connected: 'Complete'
          })
      );
  }
}

export const resetMerchant = () => ({
  type: ActionTypes.RESET_MERCHANT
});

export const validateClaim = () => {
  return (dispatch, getState) => {
    const { search } = getState();
    const vendor = new Vendor();
    const vendorId = search.get('selectedMerchantId');

    return vendor.$get(vendorId, 'id', false)
      .then(res => dispatch(replaceBusinessInfo(vendorId)))
      .then(res => dispatch(searchActiveMerchants(fromJS([vendorId], false))))
      .then(res => dispatch({
        type: ActionTypes.REQUEST_CLAIM,
        payload: true
      }))
      .then(res => Events
        .provide('kissmetrics', true)
        .log(
          'record',
          'Subscriber Onboarding 2: Complete Claim', {
            vendorId: vendorId,
            'Claim Business': 'Yes'
          }
        ))
      .then(res => dispatch(push('/plan')));
  }
}

export const completeClaim = vendorId => {
  return (dispatch, getState) => {
    return Events
			.provide('kissmetrics', true)
			.log(
				'record',
				'Subscriber Onboarding 2a: Complete Claim', {
          vendorId: vendorId,
					'Claim Business - Completed': 'Yes'
				}
      )
      .provide('facebook', true)
      .log('Claimed', {
        vendorId: vendorId,
        value: '0.00',
        currency: 'USD'
      });
  }
}

export const adminClaim = (vendor, userId, claimed, plan) => {
  return (dispatch, getState) => {

    const v = vendor.withMutations(map => map
      .set('user_id', claimed ? userId : null)
      .set('claimed', claimed)
      .set('plan', plan ? plan : vendor.plan)
    )
    return v.$put();
  }
}

export const getVouchersByDeals = () => {
  return (dispatch, getState) => {
    const dealIds = getState()
      .entities
      .get('deals').map(d => d.id)
      .join();

    if (dealIds === '') return Promise.resolve(null);

    return api().get({
      resource: 'vouchers?filter[deal_id]=' + dealIds + '&filter[status]=available,redeemed'
    })
    .then(res => dispatch(receiveEntities(res.data)))
  }
}

export const searchVoucher = id => (dispatch, getState) => {
  Events
    .provide('kissmetrics', true)
    .log(
      'record',
      'Merchant Searched for Voucher', {
        user: getState().customer.get('account').get('email'),
        vendorId: getState().customer.get('account').get('activeVendorId'),
        voucher: id
      });

  return api().get({
    resource: 'vouchers/' + id.toUpperCase()
  });
}

export const redeemVoucher = (id, total) => {
  return (dispatch, getState) => {
    Events
      .provide('kissmetrics', true)
      .log(
        'record',
        'Merchant Redeemed Voucher', {
          user: getState().customer.get('account').get('email'),
          vendorId: getState().customer.get('account').get('activeVendorId'),
          voucher: id
        });

    return api().put({
      id: id.toUpperCase(),
      resource: 'vouchers'
    }, api().payload('vouchers', {
      id: id.toUpperCase(),
      check_total: total * 100,
      status: 'redeemed'
    }))
    .then(res => dispatch(setMessage('success', 'The voucher has been redeemed')));
  }
}

export const updateDeal = (deal, data) => {
  return (dispatch, getState) => {
    const schedule = deal.post().schedule().merge(data.schedule);

    return schedule.$put()
      .then(res => dispatch(receiveEntity(res.data, 'schedules')));
  }
}



// WEBPACK FOOTER //
// ./src/actions/merchant.js